export default __webpack_public_path__ + "static/media/signature-preview-icon.115176b2.svg";